import { CheckIcon } from "@phosphor-icons/react";
import { SpinnerTrack, SyncedSpinner } from "@/zapi-frontend/shared/ui/SyncedSpinner";

type TPrereqChapterListProps = {
  chapters: string[];
  remainingChapters?: string[];
  variant?: "bullets" | "checkmarks" | "status";
};

function ChapterStatusIcon({ status }: { status: "done" | "active" | "pending" }) {
  switch (status) {
    case "done":
      return <CheckIcon size={16} weight="bold" className="text-innoveraGreen-500 shrink-0" />;
    case "active":
      return <SyncedSpinner />;
    case "pending":
      return <SpinnerTrack />;
  }
}

const statusTextColor: Record<"done" | "active" | "pending", string> = {
  done: "text-zinc-900",
  active: "text-zinc-900",
  pending: "text-zinc-400",
};

export function PrereqChapterList({ chapters, remainingChapters, variant = "bullets" }: TPrereqChapterListProps) {
  const getStatus = (name: string): "done" | "active" | "pending" => {
    if (!remainingChapters) return "pending";
    if (!remainingChapters.includes(name)) return "done";
    if (remainingChapters[0] === name) return "active";
    return "pending";
  };

  return (
    <div className="flex flex-col gap-2">
      <p className="text-[14px] leading-[22px] text-zinc-600">
        We will generate the following prerequisite chapters as well:
      </p>
      <div className="flex flex-col gap-2">
        {chapters.map((name) => {
          const status = variant === "status" ? getStatus(name) : undefined;
          return (
            <div key={name} className="flex items-start gap-2">
              {variant === "checkmarks" ? (
                <span className="flex items-center pt-[3px] shrink-0">
                  <CheckIcon size={16} weight="bold" className="text-innoveraGreen-500" />
                </span>
              ) : variant === "status" ? (
                <span className="flex items-center pt-[3px] shrink-0">
                  <ChapterStatusIcon status={status!} />
                </span>
              ) : (
                <span className="flex items-center pt-[3px] shrink-0">
                  <span className="size-[4px] rounded-full bg-zinc-900" />
                </span>
              )}
              <span className={`text-[14px] leading-[22px] ${status ? statusTextColor[status] : "text-zinc-900"}`}>
                {name}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
